import React, { FC } from "react";
import { HashLink as Link } from "react-router-hash-link";
import mobileMenuStyles from "./mobileMenu.module.css";
import resume from "../../files/ElenaSoloveva.pdf";

interface IMobileMenuProps {
  open: boolean;
  onClick: () => void;
}
const MobileMenu: FC<IMobileMenuProps> = ({ open, onClick }) => {
  return (
    <nav
      className={`${mobileMenuStyles.menu} ${
        open ? mobileMenuStyles.inview : ""
      }`}
      onClick={onClick}
    >
      <ul className={mobileMenuStyles.navList}>
        <li className={mobileMenuStyles.listItem}>
          <Link to="/#about" smooth className={mobileMenuStyles.navLink}>
            About
          </Link>
        </li>
        <li className={mobileMenuStyles.listItem}>
          <Link to="/#jobs" smooth className={mobileMenuStyles.navLink}>
            Experience
          </Link>
        </li>
        <li className={mobileMenuStyles.listItem}>
          <Link to="/#projects" smooth className={mobileMenuStyles.navLink}>
            Projects
          </Link>
        </li>
        <li className={mobileMenuStyles.listItem}>
          <a className={mobileMenuStyles.navLink} href={resume} download>
            Resume
          </a>
        </li>
      </ul>
    </nav>
  );
};
export default MobileMenu;
